<style scoped>

  #quotations-waiting-confirmation-segment {
    min-height: 400px !important;
  }

  #info-label {
    margin-top: 110px !important;
  }

  .action-button {
    min-width: 120px;
  }

</style>

<template>
  
  <div>

    <div id="quotations-waiting-confirmation-segment" class="ui segment" :class="{ loading }">
      <div class="ui grid">
        <div class="eight wide column">
          <div class="ui basic left aligned segment no-margin no-padding">
            <h4 class="ui header no-margin no-padding">Orçamentos aguardando confirmação</h4>
            <div class="grey text" style="font-size: 12px;">
              {{ lastUpdateMessage }}
            </div>
          </div>
        </div>
        <div class="eight wide column">
          <div class="ui basic right aligned segment no-margin no-padding">
            <i class="refresh icon clickable" @click="updateChart({ force: true })"></i>
          </div>
        </div>
      </div>
      <div v-if="quotations && quotations.length > 0" class="p-10 m-t-20 animated fadeIn">
        <table class="ui very basic selectable celled tablet stackable table">
          <thead class="desktop-only">
            <tr>
              <th>Número</th>
              <th>Data</th>
              <th>Cliente</th>
              <th>Representante</th>
              <th>Total Sugerido</th>
              <th>Total Aprovado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="quotation in quotations" class="clickable" @click="onShowQuotation(quotation.id)">
              <td><strong class="mobile-only">Número: </strong>{{ quotation.id }}</td>
              <td><strong class="mobile-only">Data: </strong>{{ $formatDate(quotation.date) }}</td>
              <td><strong class="mobile-only">Cliente: </strong>{{ quotation.customerName }}</td>
              <td><strong class="mobile-only">Representante: </strong>{{ quotation.userName }}</td>
              <td><strong class="mobile-only">Total Sugerido: </strong>R$ {{ $formatCurrency(quotation.sugTotal) }}</td>
              <td><strong class="mobile-only">Total Aprovado: </strong>R$ {{ $formatCurrency(quotation.appTotal) }}</td>
              <td>
                <button class="ui mini basic button" @click="onCancelQuotation($event, quotation)">
                  <i class="times red icon"></i>
                  Cancelar
                </button>
              </td>
            </tr>                   
          </tbody>
        </table>
      </div>
      <h3 id="info-label" v-if="!loading && quotations.length == 0" class="ui center aligned icon grey text header">
        <span v-if="error">
          <i class="exclamation circle red icon animated flash"></i>
          Falha de comunicação
        </span>
        <span v-else>
          <i class="info circle icon"></i>
          Nenhum orçamento aguardando confirmação
        </span>
      </h3>
    </div>

    <div id="cancel-quotation-dialog" class="ui small modal cancel-quotation-modal">

      <div class="ui header">
        Cancelamento de Orçamento
      </div>

      <div class="content">

        <form class="ui form">
          <div class="fields">
            <div class="four wide field">        
              <label class="form-label">Número</label>
              <input type="text" :value="selectedQuotation.id" readonly="readonly">
            </div>  
            <div class="four wide field">
              <label class="form-label">Data</label>
              <div class="ui calendar">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input type="text" :value="$formatDate(selectedQuotation.date)" readonly="readonly">
                </div>
              </div>
            </div> 
            <div class="eight wide field">
              <label class="form-label">Responsável</label>
              <input type="text" :value="selectedQuotation.userName" readonly="readonly">
            </div>                
          </div>                                   
          <div class="fields">
            <div class="sixteen wide field">        
              <label class="form-label">Cliente</label>
              <input type="text" :value="selectedQuotation.customerName" readonly="readonly">
            </div> 
          </div>
          <div class="fields">
            <div class="sixteen wide field">        
              <label class="form-label">Motivo <span class="red text">*</span></label>
              <select id="select-reason" class="ui fluid dropdown" v-model="cancelReason">
                  <option value="">Selecione...</option>
                  <option value="01">CLIENTE DESISTIU</option>
                  <option value="02">CLIENTE FECHOU COM UM CONCORRENTE</option>
                  <option value="99">OUTRO MOTIVO</option>
              </select>  
            </div> 
          </div>
          <div class="fields">
            <div class="sixteen wide field">        
              <label class="form-label">
                Observações <span v-if="cancelReason == '99'" class="red text animated flash">*</span>
              </label>
              <input type="text" v-model="cancelComments">
            </div> 
          </div>
        </form> 

        <div class="ui orange message">
          <i class="exclamation circle icon"></i> Essa operação é irreversível
        </div> 

      </div>

      <div class="actions">
        <button class="action-button ui basic button" @click="onAbortCancel()">
          <i class="reply icon"></i>
          Sair
        </button>
        <button type="button" class="action-button ui basic red button" :class="{ loading: canceling }" 
          @click="onConfirmCancel()">
          <i class="times icon"></i>
          Cancelar
        </button>      
      </div>

    </div>

  </div>

</template>

<script>

  import { DashboardService, QuotationService } from "@/services"
  import { Message, moment } from "@/utils"

  export default {

    data() {
      return {
        loading: true,
        error: false,
        canceling: false,
        quotations: [],
        lastUpdateMessage: "",
        setIntervalId: null,
        selectedQuotation: {},
        cancelReason: "",
        cancelComments: "",
      }
    },
   
    mounted() {      

      $("#cancel-quotation-dialog").modal({ autofocus: false })
      $("#select-reason").dropdown()

      this.setIntervalId = setInterval(this.updateLastUpdateMessage, 60000)

      this.updateChart()
    },

    beforeDestroy() {
      clearInterval(this.setIntervalId)
      $(".cancel-quotation-modal").remove()
    },

    methods: {      

      async updateChart(data) {

        let forceUpdate = (data && data.force)

        this.loading = true
        this.error = false

        try {

          let labels = []
          let colors = []
          let values = []

          if (!forceUpdate && this.$store.state.quotationsWaitingConfirmationChartData) {
            this.quotations = this.$store.state.quotationsWaitingConfirmationChartData.quotations
          } else {
            this.quotations = await DashboardService.getQuotationsWaitingConfirmation()
            this.$store.commit("setQuotationsWaitingConfirmationChartData", { 
              quotations: this.quotations, 
              lastUpdate: new Date(), 
            })
          }          

          this.loading = false

          this.updateLastUpdateMessage()

        } catch (error) {

          this.loading = false
          this.error = true
          this.quotations = []

          this.updateLastUpdateMessage()

          this.$errorHandler(error, { silent: true })
        }
      },

      updateLastUpdateMessage() {

        if (this.$store.state.quotationsWaitingConfirmationChartData) {          
          this.lastUpdateMessage = "Atualizado " + moment(this.$store.state.quotationsWaitingConfirmationChartData.lastUpdate).fromNow() 
        } else {
          this.lastUpdateMessage = ""
        }   
      },

      onShowQuotation(id) {
        QuotationService.showQuotation(id)        
      },

      onCancelQuotation($event, quotation) {

        $event.stopPropagation()

        this.selectedQuotation = quotation

        $("#cancel-quotation-dialog").modal("show")
      },

      onAbortCancel() {
        $("#cancel-quotation-dialog").modal("hide")
      },

      async onConfirmCancel() {

        if (!this.validCancel())
          return

        this.canceling = true
        
        try {

          await QuotationService.cancel({
            quotationId: this.selectedQuotation.id,
            reason: this.cancelReason,
            comments: this.cancelComments,
          })     

          $("#cancel-quotation-dialog").modal("hide")

          Message.success("Orçamento cancelado com sucesso")

          this.cancelReason = ""
          this.cancelComments = ""
          this.canceling = false

          $("#select-reason").dropdown("clear")

          this.updateChart({ force: true })
          
        } catch (error) {
          
          this.canceling = false

          this.$errorHandler(error)
        }

      },

      validCancel() {

        let isOk = true
        let message = ""

        if (!this.cancelReason) {

          message = "Informe o motivo do cancelamento"

        } else if (this.cancelReason == "99" && !this.cancelComments) {

          message = "Informe alguma observação sobre o motivo do cancelamento"
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },
    },
    
  }
</script>
